import { TournamentBracketMatchGameStatus } from '@okletsplay/core';
import { BracketSeedMatchGameEntity } from 'app/interfaces/entity';
import { useMemo } from 'react';

export const useEditMatchGames = (matchGames: BracketSeedMatchGameEntity[]) => {
  const editableIndexes = useMemo(() => {
    const runningMatchGameIndex = matchGames.findIndex(
      (matchGame) => matchGame.status === TournamentBracketMatchGameStatus.Running
    );

    return matchGames
      .map((matchGame, index) => {
        const status = matchGame.status;
        const editableGamesCount = Math.floor(matchGames.length / 2);
        if (status === TournamentBracketMatchGameStatus.Running) {
          return index;
        }

        if (
          editableGamesCount >= runningMatchGameIndex &&
          status === TournamentBracketMatchGameStatus.Completed
        ) {
          return index;
        }
      })
      .filter((position) => typeof position === 'number');
  }, [matchGames]);

  return { editableIndexes };
};
